import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Paper } from '@mui/material';
import classnames from 'classnames';
import { useScrollbarStyles } from 'modules/common/styles/useScrollbarStyles';
import { CopyrightFooter } from 'modules/common/components/CopyrightFooter';
import NotesInsights from './Notes/NotesInsights';
import InsightsHeader from './headers/InsightsHeader';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 'unset',
    backgroundColor: theme.palette.information.pageBackground,
    width: '100%'
  }
}));

const InsightsUserPageFC: React.FC = () => {
  const classesScrollbar = useScrollbarStyles();
  const classes = useStyles();
  return (
    <Paper
      className={classnames(classes.root, classesScrollbar.scrollbar)}
      square
      elevation={0}
      data-testid="insights-user-page"
    >
      <InsightsHeader />
      <NotesInsights />
      <Grid container justifyContent={'center'}>
        <CopyrightFooter />
      </Grid>
    </Paper>
  );
};

export default memo(InsightsUserPageFC);
